import { ValueProps } from "common/with-value-for";
import { LazyTimeSlider } from "./time-slider";

export const MinuteSlider = ({ value, onChange }: ValueProps<number>) => {
  return <LazyTimeSlider maxValue={59} value={value} onChange={onChange} />;
};
